<template>
  <v2-modal
    :show="show"
    title="Wishlists sharing results"
    @close="onClose"
  >
    <div>
      <p class="v2-text-sm v2-font-bold v2-mb-3">
        {{ getSubHeader }}
      </p>
      <div class="v2-share-errors">
        <div v-if="successfullySharedSelections.length">
          <p class="v2-text-sm v2-font-bold v2-text-success">
            Successfully shared:
          </p>
          <ul class="v2-share-errors__list">
            <li
              v-for="(message, index) of successfullySharedSelections"
              :key="'success_' + index"
            >
              {{ message.name }}
            </li>
          </ul>
        </div>

        <div
          v-if="failedSharedSelections.length"
          class="v2-mt-3"
        >
          <p class="v2-text-sm v2-font-bold v2-text-warning">
            Follow up:
          </p>
          <ul class="v2-share-errors__list">
            <li
              v-for="(message, index) of failedSharedSelections"
              :key="'error_' + index"
            >
              {{ message.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <template #footer>
      <v2-button
        v-if="failedSharedSelections.length"
        :disabled="isProcessingFollowUp"
        :loading="isProcessingFollowUp"
        @click="onFollowUp"
      >
        {{ isProcessingFollowUp ? 'Sending...' : 'Follow up' }}
      </v2-button>
      <v2-button
        variant="outline"
        :disabled="isProcessingFollowUp"
        @click="onClose"
      >
        {{ failedSharedSelections.length ? "Don't follow up" : 'Close' }}
      </v2-button>
    </template>
  </v2-modal>
</template>

<script>
import { toRef } from '@vue/composition-api'
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import { useShareSelectionsError } from '@/composables/useShareSelectionsError'

export default {
  name: 'V2ShareSelectionsErrorModal',
  components: { V2Modal, V2Button },
  props: {
    show: { type: Boolean, default: false },
    messages: { type: Array, default: () => [] },
  },
  setup(props, { emit }) {
    const messagesRef = toRef(props, 'messages')
    const se = useShareSelectionsError(messagesRef)

    const closeFn = () => emit('close')

    return {
      ...se,
      onClose() {
        se.onCloseModal(closeFn)
      },
      onFollowUp() {
        se.onClickFollowUp(closeFn)
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-share-errors {
  max-height: 400px;
  overflow-y: auto;

  &__list {
    list-style: none;
    padding: 0;
    margin: var(--v2-space-1) 0 0;

    li {
      padding: var(--v2-space-1) 0;
      font-size: 0.875rem;
      color: var(--v2-muted-foreground);
    }
  }
}

.v2-text-success { color: var(--v2-success); }
.v2-text-warning { color: var(--v2-warning); }
</style>
